export const XERO_QUERY_KEYS = {
  GET_XERO_SIGNUP_URL: 'getXeroSignupUrl',
};
